import { formValueSelector } from 'redux-form';

import * as bootstrapCIs from './bootstrapCIs';
import * as samplingDistributions from './samplingDistributions';
import * as randomizationHypothesisTesting from './randomizationHypothesisTesting';

export * from './names';

export { default } from './reducer';

export {
  bootstrapCIs,
  samplingDistributions,
  randomizationHypothesisTesting
};

const datasetSourceFormSelector =
  formValueSelector('DatasetSource');

export const isDatasetCustom = state =>
  datasetSourceFormSelector(state, 'source') === 'custom';

export const isDatasetPredesigned = state =>
  datasetSourceFormSelector(state, 'source') === 'predesigned';
